module.exports = "dropzone>.dropzone.dz-wrapper .dz-message{ min-height: 50px !important;}"


//////////////////
// WEBPACK FOOTER
// ./src/app/home-mobileapp/home-mobileapp.component.css
// module id = ./src/app/home-mobileapp/home-mobileapp.component.css
// module chunks = main